import * as React from 'react';
import { observer } from 'mobx-react';

// Types
import { ITag } from '../AppNetworkPeople/AppNetworkPeople';
export type ITag = ITag;

// Components
import Container from '../../components/Container';
import Paper from '../../components/Paper';
import Toolbar from '../../components/Toolbar';
import Typography from '../../components/Typography';

import TagTable from './TagTable';

//
interface IProps {
  getTags: () => void;
  tags: ITag[] | null;
  onTagRemove: (tagId: string) => void;
}

class AppNetworkMe extends React.Component<IProps> {
  componentDidMount() {
    this.props.getTags();
  }
  render() {
    return (
      <Container size="lg" padded={true}>
        <Paper>
          <Toolbar style={{ height: 56 }}>
            <Typography type="title">Tags</Typography>
          </Toolbar>
          <TagTable
            tags={this.props.tags}
            onTagRemove={this.props.onTagRemove}
          />
        </Paper>
      </Container>
    );
  }
}

export default observer(AppNetworkMe);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleMyTags/AppNetworkPeopleMyTags.tsx